import { symbolToken } from '@servicetitan/react-ioc';
export const NOTIFICATIONS_CHANNEL_TOKEN = symbolToken('NOTIFICATIONS_CHANNEL_TOKEN');
//# sourceMappingURL=notifications-channel.js.map